<script setup lang="ts">
import { RouterLink } from 'vue-router'

const props = defineProps<{
  message: string
  showStop?: boolean
  rewardName?: string
  customLinks?: string[]
}>()

interface MessageBlock {
  type: 'text' | 'link'
  content: string
  url?: string
}

const messageBlocks = computed(() => {
  const text = props.message
  const blocks: MessageBlock[] = []

  const parts = text.split(/((?:https?:\/\/)?pngo\.fr\/[a-zA-Z0-9_-]+)/)
  let customLinkIndex = 0

  parts.forEach((part) => {
    if (!part) return

    const pngoMatch = part.match(/(?:https?:\/\/)?pngo\.fr\/([a-zA-Z0-9_-]+)/)
    if (pngoMatch) {
      let url = `/preview/${pngoMatch[1]}`
      if (props.rewardName && part === 'pngo.fr/reward') {
        url += `?reward=${props.rewardName}`
      }

      if (props.customLinks && part === 'pngo.fr/link') {
        url += `?link=${props.customLinks[customLinkIndex]}`
        customLinkIndex++
      }

      blocks.push({
        type: 'link',
        content: part,
        url
      })
    } else {
      blocks.push({
        type: 'text',
        content: part
      })
    }
  })

  return blocks
})
</script>
<template>
  <div class="break-words">
    <template v-for="(block, index) in messageBlocks" :key="index">
      <RouterLink v-if="block.type === 'link'" :to="block.url!" class="underline" target="_blank">
        {{ block.content }}
      </RouterLink>
      <span v-else>{{ block.content }}</span>
    </template>
    <span v-if="showStop"> STOP 36966</span>
  </div>
</template>
